export default __webpack_public_path__ + "static/media/uploader-caresens-2.30c65de5.png";